import { Order } from "@/utils/peppol/order";
import { InboxreaderPurchaseFile } from "./inboxreader-purchase-file";

export class InboxreaderPurchase {
	ID:number = 0;
	Text:string = "";
	Subject:string = "";
	From:string = "";
	OriginalFrom:string = "";
	To:string = "";
	DateCreated:Date = new Date();
	MessageID:string = ""
	Source:string = "";
	Files:InboxreaderPurchaseFile[] = [];
	FilesCount:number = 0;
	PeppolOrder:Order | null = null;
	PeppolHash:string = "";
	PeppolHashIsDuplicate:boolean = false;
	NoteForBookkeeper:string = "";

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.Text = data.Text;
		this.Subject = data.Subject;
		this.From = data.From;
		this.OriginalFrom = data.OriginalFrom;
		this.To = data.To;
		this.DateCreated = new Date(data.DateCreated);
		this.MessageID = data.MessageID;
		this.Source = data.Source || "email";
		this.Files = (data.Files || []).map((d:any)=>new InboxreaderPurchaseFile(d));
		this.FilesCount = data.FilesCount;
		this.PeppolHash = data.PeppolHash;
		this.PeppolHashIsDuplicate = data.PeppolHashIsDuplicate;
		if (data.PeppolOrder) {
			this.PeppolOrder = new Order(data.PeppolOrder);
		}
		this.NoteForBookkeeper = data.NoteForBookkeeper;
	}

	public isUpload():boolean{
		return this.Source == "upload";
	}

	public getJSON(){
		return {
			ID: this.ID,
			Text: this.Text,
			Subject: this.Subject,
			From: this.From,
			OriginalFrom: this.OriginalFrom,
			To: this.To,
			DateCreated: this.DateCreated,
			MessageID: this.MessageID,
			Source: this.Source,
			Files: this.Files.map(f=>f.getJSON()),
			FilesCount: this.FilesCount,
			PeppolOrder: this.PeppolOrder,
			PeppolHash: this.PeppolHash,
			PeppolHashIsDuplicate: this.PeppolHashIsDuplicate,
			NoteForBookkeeper: this.NoteForBookkeeper
		};
	}
}